import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
// import "./VideoRowScrollMock.css";
import "../../shared/styles/CardSlideForm.css"
import { BsYoutube, BsChevronLeft, BsChevronRight } from "react-icons/bs";



function ytEmbedUrl(videoId) {
  return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
}

export default function VideoRowScrollMock() {
  const scrollerRef = useRef(null);
  const initialScrollRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const videos = useMemo(
    () => [
      { id: "rUBxL_fpCVM", title: "Ep 1 - ขนของแบบเลิ่กลั่ก ไม่ทันพักกลายเป็นรับของโจร" },
      { id: "ZhPqruRccvY", title: "Ep 2 - แม่ฝากเลี้ยงด้วยความหวัง แต่ชีวิตหนูต้องพังเพราะข่มขืน" },
      { id: "0kncNMfOEtk", title: "Ep 3 - เพื่อนรักเพื่อนร้าย เกือบฆ่ากันตายเพราะไก่ชน" },
      { id: "cB6gnN7K5lw", title: "Ep 4 - ผัวซ่อนรักซ้อน เมียตามไปช็อก จบด้วยคำว่าเลิก" },
      { id: "qnizbP95VIk", title: "Ep 5 - เมาแล้วซ่าอย่าปากดี เดี๋ยวเป็นผีเฝ้ารากมะม่วง" },
      { id: "1pmTL_ysCo0", title: "Ep 6 - ในโซเชียลอย่างเฟี้ยว สุดท้ายไปยืนเหี่ยวอยู่หน้าบัลลังก์" },
    ],
    []
  );

  // ✅ อัปเดตสถานะลูกศร (ซ้าย/ขวา)
  const updateArrows = useCallback(() => {
    const el = scrollerRef.current;
    if (!el) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;

    // จำค่าเริ่มต้น (เผื่อมี padding/scrollLeft ไม่ใช่ 0)
    if (initialScrollRef.current === null) {
      initialScrollRef.current = scrollLeft;
    }
    const base = initialScrollRef.current ?? 0;

    // ถ้าคอนเทนต์ไม่เกินพื้นที่ที่เห็น = ไม่ต้องมีลูกศรเลย
    if (scrollWidth <= clientWidth + 1) {
      setCanScrollLeft(false);
      setCanScrollRight(false);
      return;
    }

    const atStart = scrollLeft <= base + 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

    setCanScrollLeft(!atStart);
    setCanScrollRight(!atEnd);
  }, []);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    // รีเซ็ตตำแหน่งเริ่ม (ถ้าต้องการให้เริ่มที่ซ้ายสุดเสมอ)
    el.scrollLeft = 0;
    initialScrollRef.current = null;

    // อัปเดตครั้งแรก
    updateArrows();

    el.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);

    return () => {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [videos, updateArrows]);

  const handleSlideNext = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const scrollAmount = el.clientWidth * 0.85;
    el.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  const handleSlidePrev = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const scrollAmount = el.clientWidth * 0.85;
    el.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  };

  return (
    <>
        <div className="d-flex justify-content-between align-items-end mb-2">
        <h3>
            <strong>
            <BsYoutube /> วิดีโอแนะนำ
            </strong>
        </h3>
        </div>

        {/* ✅ ใช้ wrapper แบบเดียวกับ CSS ชุดลูกศร */}
        <div className="slide-wrapper">
        {/* ✅ ซ่อน/แสดงตามสถานะ */}
        {canScrollLeft && (
            <button
            type="button"
            className="slide-arrow slide-arrow-left"
            onClick={handleSlidePrev}
            aria-label="เลื่อนซ้าย"
            >
            <BsChevronLeft size={22} />
            </button>
        )}

        {canScrollRight && (
            <button
            type="button"
            className="slide-arrow slide-arrow-right"
            onClick={handleSlideNext}
            aria-label="เลื่อนขวา"
            >
            <BsChevronRight size={22} />
            </button>
        )}

        {/* ✅ scroller: ใช้ class เดียวกับบทความ เพื่อให้ CSS เดิมทำงาน */}
        <div ref={scrollerRef} className="article-slide-container">
            {videos.map((v) => (
            <div key={v.id} className="slide-item">
                <div className="card video-slide-item h-100">
                <div className="ratio ratio-16x9 bg-dark">
                    <iframe
                    src={ytEmbedUrl(v.id)}
                    title={v.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    style={{ border: 0 }}
                    />
                </div>

                <div className="card-body">
                    <div className="video-title fw-semibold">{v.title}</div>
                </div>
                </div>
            </div>
            ))}
        </div>
        </div>
    </>
    );

}


